class IndustriesSelect extends HTMLSelectElement {
  constructor() {
    super();
    this.template = document.createElement('template');
  }

  // NOT TESTED
  requestUpdate(data){
    this.data = data;
    let options = this.data.map(industry => `<option value="${industry.id}">${industry.display_name}</option>`).join("")
    this.template.innerHTML =`
    <option value=null>Choose</option>
    ${options}
    `
    
    Array.from(this.options).map(opt=> {
        opt.parentNode.removeChild(opt);
    });

    this.appendChild(this.template.content.cloneNode(true));

    if(this.getAttribute("data-selected") != null) {
      this.value = this.getAttribute("data-selected");
    }
    if(this.selectedOptions.length == 0) {
      this.value = "null"
    }
  }

  async connectedCallback() {
    this.data_binder = new DataBinder("/admin/industries.json", true);
    this.data_binder.register(this);
    if(this.data_binder.data) this.requestUpdate(this.data_binder.data);
  }

  disconnectedCallback(){
    this.data_binder.unregister(this);
  }
}

customElements.define('industries-select', IndustriesSelect, {extends: 'select'});